module.exports = __webpack_public_path__ + "static/media/ir_emitter.bc3f39a0.jpg";